// extracted by mini-css-extract-plugin
export default {"terms-of-service-template":"styles_terms-of-service-template__UpcnC"};